<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-12 col-md-3 d-print-none d-flex">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          class="col-12 col-md-9 d-flex align-items-center"
          *ngIf="documentType && documentType?.id"
          [ngClass]="service.getCategoryClass(documentType)"
        >
          <h1 class="mb-0">
            {{ documentType.code + " - " + documentType.description }}
          </h1>
          <span class="ml-3"
            >({{ service.getCategoryName(documentType) }})</span
          >
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <mat-nav-list>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <app-document-type-list
              #documentTypeList
              [filter]="filter"
              (documentTypeSelected)="selectedRow($event)"
            >
            </app-document-type-list>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="hasPrivilege(privilegeEnum.CreateDocumentType)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="sidenav-content pb-5">
        <app-document-type-details
          [documentType]="documentType"
          (changed)="documentType = $event"
        >
        </app-document-type-details>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
